import { message } from 'ant-design-vue';
import axios from 'axios'
import { useAxios } from '@vueuse/integrations/useAxios'
import router from "@/router";
const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    // baseURL: 'http://172.25.2.3:80',
    timeout: 100000
})
instance.interceptors.request.use(config => {
    const token = localStorage.getItem("edb-authorization-token")
    if (token && !config.url.endsWith("/login") && !config.url.endsWith("/captchaImage")) {
        config.headers["Authorization"] = token
        // "Bearer " +
    }
    return config
}, err => {
    return Promise.reject(err)
});
instance.interceptors.response.use(res => {

    let res_data = res.data
    if (res_data.code && res_data.code != 0) {
        message.error(res_data.msg || '网络请求错误');
        if ( res_data.code == 40003|| res_data.code == 40000 ) {
            localStorage.clear()
            setTimeout(() => {
              location.href = '/login'
            }, 20)
        }

        return Promise.reject(res_data)
    }
    return res_data
}, err => {
    return Promise.reject(err)
});

// 简单包装一层，让参数更直观
export function useRequest(config, useAxiosOptions = { immediate: true }) {
  return useAxios(
    config.url,
    config,
    instance,
    useAxiosOptions
  )
}

export default instance
